<template>
    <div class="navigator">
        <router-link class="navigator-title" :to="returnLink">
            <span>{{ subTitle }}</span>
        </router-link>
        <div class="navigator-main">
            <ul class="main-nav" v-if="levelOneNavi">
                <router-link to="/xsdt">
                    <span>学术动态</span>
                    <template v-show="index == 0">
                        <em class="up"></em>
                        <em class="down"></em>
                    </template>
                </router-link>
                <router-link to="/xsjl">
                    <span>学术交流</span>
                    <template v-show="index == 1">
                        <em class="up"></em>
                        <em class="down"></em>
                    </template>
                </router-link>
                <a target="_blank" href="http://www.qiyekexie.com/portal/new-big-screen/dist/index.html#/newHome">
                    <span>创新创业</span>
                    <template v-show="index == 2">
                        <em class="up"></em>
                        <em class="down"></em>
                    </template>
                </a>
                <router-link to="/xhqj">
                    <span>学会全景</span>
                    <template v-show="index == 3">
                        <em class="up"></em>
                        <em class="down"></em>
                    </template>
                </router-link>
            </ul>
            <ul class="main-nav" v-else>
                <router-link to="/xsdt" class="router-link-active second-level-title">
                    <span>{{ currTitle }}</span>
                    <em class="up"></em>
                    <em class="down"></em>
                </router-link>
            </ul>
        </div>
        <div class="circle-bar"></div>
    </div>
</template>
<script>
    export default {
        name: 'Navigator',
        data() {
            return {
                levelOneNavi: true,
                subTitle: "",
                currTitle: ""
            }
        },
        created() {
            let { subTitle, returnLink, title } = this.$route.meta;
            this.subTitle = subTitle || "首页";
            this.returnLink = returnLink || "/";
            this.index = 1;
            if (title && subTitle) {
                this.levelOneNavi = false;
                this.currTitle = title || this.subTitle;
            }

        },
        methods: {},
    }
</script>
<style lang="scss">
@import "@/assets/scss/mixins/_variables";

.navigator {
    height: 7.2232645%;
    position: relative;
    width: 100%;

    &-main {
        position: relative;
        width: 40.8992416%;
        height: 100%;
        margin: 0 auto;
        z-index: 2;
        background: url('~@/assets/images/nav-bg.png') no-repeat center top / auto 90%;

        .main-nav {
            margin: 0 15%;
            text-align: center;
            line-height: .67rem;

            a {
                display: block;
                float: left;
                width: 25%;
                height: .67rem;
                font-size: 0.32rem;
                font-weight: bold;
                color: #fff;
                cursor: pointer;
                &.second-level-title{
                    width:100%;
                    text-align: center;
                }

                span {
                    background-image: linear-gradient(to right, #5566ff, #3141ca);
                    background-clip: text;
                    -webkit-text-fill-color: transparent;
                }

                &:hover,
                &.router-link-active {
                    position: relative;
                    background: url('~@/assets/images/nav-selected-bg.png') no-repeat center center / 100% auto;
                    cursor: pointer;

                    em {
                        position: absolute;
                        left: 50%;
                        width: .42rem;
                        height: .21rem;
                        margin-left: -0.21rem;
                        background: url('~@/assets/images/nav-selected-mark.png') no-repeat center top / 100% auto;

                        &.up {
                            top: 0;
                        }

                        &.down {
                            bottom: 0;
                            transform: rotate(180deg);
                        }
                    }

                    span {
                        background: radial-gradient(circle, #fff 0, #989fe4 100%);
                        background-clip: text;
                        -webkit-text-fill-color: transparent;
                    }
                }
            }
        }
    }

    .circle-bar {
        position: absolute;
        right: 0;
        top: 0.3rem;
        width: 5.67rem;
        height: 0.36rem;
        z-index: 1;
        background: url('~@/assets/images/decoration-line.png') no-repeat center/100% 100%;
    }

    &-title {
        float: left;
        min-width: 10.42%;
        height: 64.1%;
        line-height: 0.67rem;

        margin: {
            top: 0.14rem;
            left: 2.08%;
        }

        background: url('~@/assets/images/return-bg.png') no-repeat center /100% 100%;

        span {
            display: block;
            font-size: 0.32rem;
            color: $title-text-color;
            padding-left: 0.76rem;
            min-width: 5em;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
    }
}
</style>